"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticFieldType = void 0;
// eslint-disable-next-line no-shadow
var StaticFieldType;
(function (StaticFieldType) {
    StaticFieldType["ASSET_TYPE"] = "assetType";
    StaticFieldType["ISSUE_FLAG"] = "issueFlag";
    StaticFieldType["ISSUE_TYPE"] = "issueType";
    StaticFieldType["ISSUE_STATUS"] = "issueStatus";
    StaticFieldType["ISSUE_DUESTATUS"] = "issueDueStatus";
    StaticFieldType["ISSUE_RESTIME"] = "issueResolutionTime";
    StaticFieldType["OP_STATUS"] = "opStatus";
    StaticFieldType["OP_HASISSUES"] = "opHasIssues";
    StaticFieldType["OP_PASSSTATUS"] = "opPassStatus";
    StaticFieldType["OP_TYPE"] = "opType";
    StaticFieldType["OP_GRADE"] = "opGrade";
    StaticFieldType["ORG_STATUS"] = "orgStatus";
    StaticFieldType["STAFF_APPSTATUS"] = "staffAppStatus";
    StaticFieldType["STAFF_WEBSTATUS"] = "staffWebStatus";
    StaticFieldType["TASK_TYPE"] = "taskType";
    StaticFieldType["TASK_STATUS"] = "taskStatus";
    StaticFieldType["USER_TYPE"] = "userType";
    StaticFieldType["WORKFLOW_EVENT"] = "workflowEvent";
    StaticFieldType["WORKFLOW_ACTION"] = "workflowAction";
})(StaticFieldType = exports.StaticFieldType || (exports.StaticFieldType = {}));
exports.default = StaticFieldType;
